<script>
import {reactive} from "vue";

export default {
  components: {},
  props: {
    /**
     * Whether the table is loading.
     */
    loading: {
      type: Boolean,
      default: true
    },
    /**
     * Whether the has data.
     */
    hasData: {
      type: Boolean,
      default: false
    },
    /**
     * If true will hide table header.
     */
    hideHeader: {
      type: Boolean,
      default: false
    },
    /**
     * The message to show where there is no data available.
     */
    noDataMessage: {
      type: String,
      default: "Not enough data to report on."
    },
    /**
     * Number of static rows to show in the loading state
     */
    loadingRows: {
      type: Number,
      default: 10
    },
    /**
     * Number of static cells to show in the loading rows
     */
    loadingCells: {
      type: Number,
      default: 2
    }
  },
  setup(props) {
    props = reactive(props);

    return {
      classes: {
        'hide-header': props.hideHeader
      }
    };
  },
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<template>
  <div class="table-wrapper min-h-48">
    <template v-if="loading || hasData">
      <table :class="classes">
        <thead v-if="!hideHeader">
          <slot name="tableHeader" />
        </thead>
        <tbody>
          <template v-if="loading">
            <tr
              v-for="i in loadingRows"
              :key="i"
              class="animate-pulse"
            >
              <td
                v-for="x in loadingCells"
                :key="x"
              >
                <div class="h-8 bg-gray-300 rounded" />
              </td>
            </tr>
          </template>
          <template v-else>
            <slot name="tableBody" />
          </template>
        </tbody>
      </table>
    </template>
    <template v-else>
      <table :class="classes">
        <thead v-if="!hideHeader">
          <slot name="tableHeader" />
        </thead>
      </table>
      <div class="no-data-message body-2-regular flex flex-row items-center justify-center mt-8">
        {{ noDataMessage }}
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

table {
  width: 100%;

  th,
  :deep(th) {
    text-align: left;
    text-transform: uppercase;
    padding: $space-sm $space-sm $space-lg $space-sm;
  }

  td,
  :deep(td) {
    padding: $space-lg $space-sm;
    font-size: 12px;
  }

  tbody tr,
  tbody :deep(tr) {
    &:nth-child(odd) {
      @apply bg-white;
    }

    &:nth-child(even) {
      @apply bg-table_gray;
    }
  }

  &.hide-header {
    tbody tr,
    tbody :deep(tr) {
      &:nth-child(odd) {
        @apply bg-white;
      }

      &:nth-child(even) {
        @apply bg-table_gray;
      }
    }
  }
}
</style>
